module.exports = __webpack_public_path__ + "img/magento-security-services_small.74f08987.webp";